import VariableSection from './VariableSection';
import { VariableSectionProps, VariableSectionValueProps } from './types';

export type { VariableSectionProps, VariableSectionValueProps };
export default VariableSection;
